
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({

    appBarSpacer: {
        minHeight: '64px',
        background: 'white',
    },
    header: {
        background: '#ECF2FF',
        display: 'flex',
        alignItems: 'center',
        padding: "0 15px",
        height: '58px',
        "& h2": {
            padding: '0px 15px',
            // fontSize: '22px',
            // fontWeight: 600,
            // lineHeight: '28.8px',
            // color: '#2D4D95',
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 600,
             fontSize: window.isMobileView ? window.isMobile425 ? 14:18:24,
            lineHeight: '29px',
            color: '#2D4D95',
        }
    },
    container: {
        padding: '15px',
        paddingBottom: window.isIpadView ? '100px': '10px',
    },
    mobileTableList: {
        display: 'flex',
        flexFlow: 'wrap',
        margin: '8px 0',
        background: '#F0F0F0',
        padding: '12px 5px',
        borderRadius: '10px',
        fontSize: '16px',
        "& div": {
            padding: '0 10px',
        },
        "&:nth-child(even)": {
            background: '#DCECFF',

        }
    },
    greyBorderBox: {
        border: '1px solid #e3e3e3',
        padding: '20px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        margin: '5px',
        flexFlow: 'column',
        minHeight: '270px',
        borderRadius: '19px',
        "& h3": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '28px',
            lineHeight: '39px',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: '#3C4549',
            margin: '18px 0px',
        },
        "& img": {
            marginTop: '20px'
        }
    },
    changeBtn: {
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
        lineHeight: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        backgroundColor: '#0049A3',
        borderRadius: '4px',
        marginRight: '5px',
        padding: window.isMobileView? window.isMobile425 ? '4px 8px':'6px 12px':'8px 16px',
        textTransform: 'unset !important',
        cursor: 'pointer',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },
    table: {
        padding: '0px 20px',
    },
    addressBookBox: {

    },
    addressBox: {        
        background: '#FDFDFD',
        padding: '5px',
    
    },
    addressBookNoRecord: {
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        margin: '50px auto',
        "& img": {
            maxWidth: window.isMobileView ? '100%' : '300px',
            margin: '20px auto',
        },
        "& h3": {
            fontWeight: 400,
            fontSize: '28px',
            lineHeight: '36px',
            color: '#B6B3B3',
        }
    },
    addressContent: {
        border: '1px solid #D9D9D9',
        borderRadius: '19px',
        textAlign: 'center',
        padding: '15px 10px',
        minHeight: '250px',
        justifyContent: 'center',
        display: 'flex',
        flexFlow: 'column',
        "& h3": {
            fontSize: '15px',
        },
        "& h4": {
            fontSize: '12px',
            margin: 0,
        },
        "& .emailLink": {
            color: '#0686D8',
            wordWrap: 'break-word',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        }
    },
    Icons: {
      display: 'flex', 
      justifyContent: 'center',
      flexFlow: 'wrap',  
        marginTop: '10px',  
        "& svg": {
            marginRight: '5px',
        }
    },
    iconLink: {
        width: '33px',
        height: '33px',
        padding: '8px',
        background: '#DEDEDE',
        borderRadius: '50px',
        overflow: 'initial',
    },
    root: {
        width: 65,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(38px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `0px solid ${theme.palette.grey[400]}`,
        backgroundColor: '#c3c3c3',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    SearchAllign:{
        display: 'flex',
        alignItems:'center',
        gap:'10px'
    },
    AllignCenter: {
        display: 'flex',
        alignContent: 'center',

        justifyContent: 'end',
        gap: '10px',
    }
}))